// extracted by mini-css-extract-plugin
var _1 = "sceneDialogPlacement-module__belowCharacter--lACVv";
export { _1 as "belowCharacter" }
